import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import carouselStyles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/carouselTemplatePreview.module.scss";

import { useShallow } from "zustand/react/shallow";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { canDeleteCard, getCarouselCards } from "../../constant";
import { useCarouselFunctions } from "../../utils/useCarouselFunctions";

import CarouselTemplateCardHeaderPreview from "./CarouselTemplateCardHeaderPreview";
import CarouselTemplateCardBodyPreview from "./CarouselTemplateCardBodyPreview";
import CarouselTemplateCardFooterPreview from "./CarouselTemplateCardFooterPreview";
import CarouselTemplateCardButtonsPreview from "./CarouselTemplateCardButtonsPreview";
import TouchTooltip from "../../utils/TouchTooltip";

const NextArrow = (arrowProps: any) => {
    const { className, style, onClick } = arrowProps;
    return (
        <button
            type="button"
            aria-label="Next card"
            className={`${className} ${carouselStyles.arrowButton}`}
            style={style}
            onClick={onClick}
        >
            <ChevronRightIcon fontSize="small" />
        </button>
    );
};

const PrevArrow = (arrowProps: any) => {
    const { className, style, onClick } = arrowProps;
    return (
        <button
            type="button"
            aria-label="Previous card"
            className={`${className} ${carouselStyles.arrowButton}`}
            style={style}
            onClick={onClick}
        >
            <ChevronLeftIcon fontSize="small" />
        </button>
    );
};

const CarouselTemplateCardPreview = (props: any) => {
    const { editable = false, displayTemplate, handleChangeText, uploadFileHandlerCarousel, removeFileHandlerCarousel, isFileUploaded, 
        handleDeleteCard, getInput, flagShowVariableTooltipForVisitWebsite, checkForAddDynamicVar, carouselInvalidId, 
        setCarouselInvalidId, inValidIdRefCarousel, handleChangeCallField, handleChangeFieldVal, handleSampleTextChangeCarousel, 
        getWebsiteUrlValue, carouselFiles
    } = props;

    const { createTemplatePayload } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
    })));

    const { isScreenBelow1250 } = useCarouselFunctions();

    const carouselCards = getCarouselCards(editable ? createTemplatePayload : displayTemplate);

    return (
        <Box className={carouselStyles.carouselSliderWrap}>
            <div className={carouselStyles.sliderContainer}>
                <Slider
                    swipe={isScreenBelow1250}
                    arrows={true}
                    dots={false}
                    infinite={false}
                    autoplay={false}
                    variableWidth={true}
                    slidesToShow={1}
                    slidesToScroll={1}
                    className={carouselStyles.sliderTemplate}
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                >
                    {carouselCards?.map((cardData: any, cardIndex: number) => (
                        <>
                            <Box
                                key={cardIndex}
                                className={carouselStyles.sliderCardBlock}
                            >
                                {editable && canDeleteCard(createTemplatePayload) && (
                                    <TouchTooltip title="Delete card" >
                                        <CloseIcon
                                            className={carouselStyles.closeIcon}
                                            onClick={() => handleDeleteCard?.(cardIndex)}
                                        />
                                    </TouchTooltip>
                                )}

                                <CarouselTemplateCardHeaderPreview
                                    cardData={cardData}
                                    cardIndex={cardIndex}
                                    carouselFiles={carouselFiles}
                                    editable={editable}
                                    uploadFileHandlerCarousel={uploadFileHandlerCarousel}
                                    removeFileHandlerCarousel={removeFileHandlerCarousel}
                                    isFileUploaded={isFileUploaded}
                                />

                                <CarouselTemplateCardBodyPreview
                                    cardData={cardData}
                                    cardIndex={cardIndex}
                                    editable={editable}
                                    handleChangeText={handleChangeText}
                                />

                                <CarouselTemplateCardFooterPreview
                                    cardData={cardData}
                                    cardIndex={cardIndex}
                                    editable={editable}
                                    handleChangeText={handleChangeText}
                                />
                            </Box>

                            <CarouselTemplateCardButtonsPreview
                                cardData={cardData}
                                cardIndex={cardIndex}
                                editable={editable}
                                getInput={getInput}
                                flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                                checkForAddDynamicVar={checkForAddDynamicVar}
                                carouselInvalidId={carouselInvalidId}
                                inValidIdRefCarousel={inValidIdRefCarousel}
                                setCarouselInvalidId={setCarouselInvalidId}
                                handleChangeCallField={handleChangeCallField}
                                handleChangeFieldVal={handleChangeFieldVal}
                                getWebsiteUrlValue={getWebsiteUrlValue}
                                handleSampleTextChangeCarousel={handleSampleTextChangeCarousel}
                            />
                        </>
                    ))}
                </Slider>
            </div>
        </Box>
    );
};

export default CarouselTemplateCardPreview;